import { useNavigate } from "react-router-dom"
import { CounterColor, CounterSecondaryComponent } from "../counter/counterSecondary"
import { setDocumentTabValue } from "../documents/slice"
import { ArchiveIcon } from "../icons/archive"
import { DocumentReceivedIcon } from "../icons/documentReceived"
import { DocumentSentIcon } from "../icons/documentSent"
import { keycloak } from "../keycloak"
import { useAppDispatch, useAppSelector } from "../redux/hooks"
import colors from "../utils/index.module.scss"

export function DashboardStandard() {
    const receivedDocs = useAppSelector(state => state.document.companiesUnseenDocumentsResponse?.find(doc => doc.companyId.toString() !== keycloak.subject)?.unseenRecived)
    const sentDocs = useAppSelector(state => state.document.companiesUnseenDocumentsResponse?.find(doc => doc.companyId.toString() !== keycloak.subject)?.unseenSent)

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <div style={{ gap: '24px', display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div
                style={{
                    display: "flex",
                    padding: "24px",
                    alignItems: "flex-start",
                    borderRadius: "24px",
                    border: "1px solid " + colors.primary100,
                    gap: "12px",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: "4px",
                        gap: "8px",
                        width: '100%'
                    }}
                >
                    <ArchiveIcon colorBase={colors.neutral200} />
                    <span style={{ flexGrow: 1 }} className="heading heading--xs typography--bold typography-primary--800">Archivi</span>
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "8px",
                        width: "100%",
                        flexWrap: 'wrap'
                    }}>
                    <CounterSecondaryComponent color={CounterColor.PRIMARY}
                        icon={<DocumentReceivedIcon colorBase={colors.primary500} />}
                        title={"Documenti ricevuti"}
                        onClick={() => { navigate('/documents'); dispatch(setDocumentTabValue(0)) }}
                        toCount={receivedDocs || 0}
                    />
                    <CounterSecondaryComponent color={CounterColor.PRIMARY}
                        icon={<DocumentSentIcon colorBase={colors.primary500} />}
                        title={"Documenti inviati"}
                        onClick={() => { navigate('/documents'); dispatch(setDocumentTabValue(1)) }}
                        toCount={sentDocs || 0}
                    />
                </div>
            </div>
        </div>
    )
}